import { useState, useEffect } from "react";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { ImLocation } from "react-icons/im";
import { db } from "../../../firebase";

export default function ImagesGallery({
  packagesDocsReady,
  packageId,
  packageSolo,
  status,
}) {
  const [image, setImage] = useState();

  useEffect(() => {
    (async () => {
      const colRef = collection(db, "images");
      const q = query(
        colRef,
        where("adminPublish", "==", true),
        where("packages", "array-contains", packageId),
        limit(1)
      );
      const snapshot = await getDocs(q);
      const doc = snapshot.docs[0];
      //   console.log("doc: ", doc);

      if (doc !== undefined) {
        const docData = doc.data();
        setImage(docData);
      }
    })();
  }, [packageId]);

  useEffect(() => {
    if (packageSolo.user === "tf0WLrTtOFSBxiSMju4rJ0qwavw2") {
      console.log("Image: ", image);
      console.log("PackageId: ", packageId);
      console.log("packageSolo: ", packageSolo);
    }
  }, [image, packageId, packageSolo]);

  return (
    <>
      {image && (
        <div className="h-3/4 md:h-4/5 rounded-md relative">
          <div className="relative h-full w-auto p-1">
            <img
              src={image.imageLinks.imageKitUrl80}
              className="max-h-full md:p-1 rounded-md object-cover object-center items-center text-center mx-auto"
              data-cy="packages-image"
              alt={`${packageSolo.name} flagship`}
            />
          </div>
          <div className="absolute rounded-md bg-opacity-90 bg-white flex left-1 bottom-1 p-1">
            <ImLocation className="text-orange-400 text-xs" />
            <span
              data-cy="packages-regions"
              className="text-orange-400 text-xs"
            >
              {packageSolo.profileRegion}
            </span>
          </div>
        </div>
      )}
      {/* </div> */}
    </>
  );
}
